import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAPIKey, testAPIKey } from '../notificationSlice';
import { notificationAPI } from '../notificationAPI';

const SendOnAPIPanel = () => {
  const dispatch = useDispatch();
  const { apiSettings, loading, error } = useSelector(state => state.notification);
  const [sendonIdInput, setSendonIdInput] = useState('');
  const [apiKeyInput, setApiKeyInput] = useState('');
  const [channelIdInput, setChannelIdInput] = useState('');
  const [apiStatus, setApiStatus] = useState(null);
  const [testResult, setTestResult] = useState(null);

  useEffect(() => {
    loadApiSettings();
  }, []);

  const loadApiSettings = async () => {
    try {
      const response = await notificationAPI.getSendOnAPISettings();
      console.log('API 설정 응답:', response); // 디버깅용
      
      // response.data에서 실제 데이터 가져오기
      const data = response.data || response;
      console.log('추출된 데이터:', data);
      
      if (Array.isArray(data) && data.length > 0) {
        const settingsData = data[0];
        console.log('설정 데이터:', settingsData);
        setApiStatus({
          is_configured: settingsData.is_configured === true,
          id: settingsData.id,
          channel_id: settingsData.channel_id || '',
          created_at: settingsData.created_at,
          updated_at: settingsData.updated_at
        });
        setChannelIdInput(settingsData.channel_id || '');
      } else {
        console.log('기본값 설정: is_configured=false');
        setApiStatus({ is_configured: false });
      }
    } catch (error) {
      console.error('API 설정 로드 실패:', error);
      setApiStatus({ is_configured: false });
    }
  };

  const handleSaveSettings = async () => {
    if (!sendonIdInput.trim()) {
      alert('센드온 아이디를 입력해주세요.');
      return;
    }

    if (!apiKeyInput.trim()) {
      alert('API 키를 입력해주세요.');
      return;
    }
    
    if (!channelIdInput.trim()) {
      alert('채널 ID를 입력해주세요.');
      return;
    }

    try {
      const combinedApiKey = apiKeyInput.trim().includes(':')
        ? apiKeyInput.trim()
        : sendonIdInput.trim() + ':' + apiKeyInput.trim();

      const updateData = {
        api_key: combinedApiKey,
        channel_id: channelIdInput.trim()
      };
      
      const response = await notificationAPI.updateSendOnAPISettings(updateData);
      setSendonIdInput('');
      setApiKeyInput('');
      setChannelIdInput('');
      await loadApiSettings();
      
      alert('API 설정이 성공적으로 저장되었습니다.');
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'API 설정 저장에 실패했습니다.';
      alert(errorMessage);
    }
  };


  return (
    <div className="api-panel">
      <div className="panel-header">
        <div className="header-content">
          <h3>센드온 API 설정</h3>
          <p>알림톡 발송을 위한 센드온 API 키를 관리합니다.</p>
        </div>
      </div>

      <div className="status-row warning" style={{ marginTop: '-16px', marginBottom: '16px' }}>
        <div className="status-indicator not-configured">
          <div className="status-icon">⚠️</div>
          <div className="status-text">
            <span className="status-description">
              반드시 센드온 설정에서 <b>지인에듀 서버 IP(152.67.203.76/32)를 허용</b>해야 합니다.<br />
              <b>설정 {'>'} 개발자 센터 {'>'} API KEY 관리</b>에서 API KEY와 허용 IP를 추가하세요.
            </span>
          </div>
        </div>
      </div>

      <div className="api-content">
        {/* API Key Management */}
        <div className="management-section">
          <div className="management-header">
            <h4>🔑 API 키 관리</h4>
            <p>보안을 위해 API 키는 서버에만 저장되며, 프론트엔드에서는 표시되지 않습니다.</p>
          </div>

          <div className="api-key-form">
            <div className="form-group">
              <label htmlFor="sendon-id-input">1. 센드온 아이디</label>
              <input
                id="sendon-id-input"
                type="text"
                value={sendonIdInput}
                onChange={(e) => setSendonIdInput(e.target.value)}
                placeholder="센드온 로그인 아이디 (예: myacademy)"
                className="api-key-input"
              />
              <p className="api-key-description">
                센드온에 로그인할 때 쓰는 아이디예요.
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="channel-id-input">2. 카카오 비즈니스 채널 아이디</label>
              <input
                id="channel-id-input"
                type="text"
                value={channelIdInput}
                onChange={(e) => setChannelIdInput(e.target.value)}
                placeholder="카카오 채널 아이디 (@ 없이, 예: myacademy)"
                className="api-key-input"
              />
              <p className="api-key-description">
                센드온에 등록한 카카오 채널(발신 프로필) 아이디예요. @ 없이 입력하세요.
              </p>
            </div>

            <div className="form-group">
              <label htmlFor="api-key-input">3. API 키</label>
              <input
                id="api-key-input"
                type="text"
                value={apiKeyInput}
                onChange={(e) => setApiKeyInput(e.target.value)}
                placeholder="센드온에서 발급받은 API 키 (예: ssk_xxxxx...)"
                className="api-key-input"
              />
              <p className="api-key-description">
                센드온 설정 &gt; API 관리에서 발급받은 키를 그대로 붙여넣으세요.
              </p>
            </div>

            <div className="save-button-row">
              <button
                className="update-button"
                onClick={handleSaveSettings}
                disabled={loading.apiKey || !sendonIdInput.trim() || !apiKeyInput.trim() || !channelIdInput.trim()}
              >
                {loading.apiKey ? '저장 중...' : 'API 설정 저장'}
              </button>
            </div>

            {/* API Status */}
              <div className="status-row" style={{ marginTop: 0}}>
                <div className={`status-indicator ${apiStatus?.is_configured ? 'configured' : 'not-configured'}`}>
                  <div className="status-icon">
                    {apiStatus?.is_configured ? '✅' : '❌'}
                  </div>
                  <div className="status-text">
                    <span className="status-title">
                      {apiStatus?.is_configured ? 'API 키 설정됨' : 'API 키 미설정'}
                    </span>
                    <span className="status-description">
                      {apiStatus?.is_configured 
                        ? 'API 키가 저장되어 있습니다.' 
                        : 'API 키를 입력하고 저장해주세요.'
                      }
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="status-row">
                <div className={`status-indicator ${apiStatus?.channel_id ? 'configured' : 'not-configured'}`}>
                  <div className="status-icon">
                    {apiStatus?.channel_id ? '✅' : '❌'}
                  </div>
                  <div className="status-text">
                    <span className="status-title">
                      {apiStatus?.channel_id ? '채널 ID 설정됨' : '채널 ID 미설정'}
                    </span>
                    <span className="status-description">
                      {apiStatus?.channel_id 
                        ? `채널 ID: ${apiStatus.channel_id}` 
                        : '채널 ID를 입력하고 저장해주세요.'
                      }
                    </span>
                  </div>
                </div>
              </div>
              
              {apiStatus?.is_configured && apiStatus?.channel_id && (
                <div className="status-row">
                  <div className="status-indicator configured">
                    <div className="status-icon">🚀</div>
                    <div className="status-text">
                      <span className="status-title">알림톡 발송 준비 완료</span>
                      <span className="status-description">모든 설정이 완료되었습니다. 알림톡 발송이 가능합니다.</span>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>

      {error.apiKey && (
        <div className="error-message">
          API 설정 중 오류가 발생했습니다: {typeof error.apiKey === 'string' ? error.apiKey : JSON.stringify(error.apiKey)}
        </div>
      )}

      <style jsx>{`
        .api-panel {
          padding: 24px;
        }

        .panel-header {
          margin-bottom: 32px;
          padding-bottom: 20px;
          border-bottom: 1px solid #E6EDEC;
        }

        .header-content h3 {
          font-size: 20px;
          margin: 0 0 8px 0;
          color: #333;
        }

        .header-content p {
          font-size: 14px;
          color: #666;
          margin: 0;
        }

        .api-content {
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .status-section,
        .management-section,
        .info-section {
          background: white;
          border: 1px solid #E6EDEC;
          border-radius: 8px;
          padding: 24px;
        }

        .status-header h4,
        .management-header h4,
        .info-header h4 {
          margin: 0 0 16px 0;
          font-size: 16px;
          color: #333;
        }

        .management-header p {
          margin: 0;
          font-size: 14px;
          color: #666;
          margin-top: -0.8rem;
        }

        .status-indicator {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px;
          border-radius: 8px;
          border: 2px solid;
        }

        .status-row {
          margin-top: 12px;
        }

        .status-indicator {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 16px;
          border-radius: 6px;
          border: 1px solid;
        }

        .status-indicator.configured {
          background: #e8f5e8;
          border-color: #00D9C0;
          color: #00806B;
        }

        .status-indicator.not-configured {
          background: #FBF4D9;
          border-color: #ffc107;
          color: #8A6D00;
        }

        .status-icon {
          font-size: 20px;
          flex-shrink: 0;
        }

        .status-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .status-title {
          font-size: 14px;
          font-weight: 600;
        }

        .status-description {
          font-size: 13px;
          opacity: 0.8;
        }

        .api-key-form {
          margin-top: 20px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          margin-bottom: 8px;
        }

        .api-key-input-row {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .api-id-input,
        .api-key-input {
          width: 100%;
          padding: 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
          box-sizing: border-box;
        }

        .api-id-input:focus,
        .api-key-input:focus {
          outline: none;
          border-color: #0E141B;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
        }

        .api-key-description {
          font-size: 13px;
          color: #666;
          margin: 8px 0 0 0;
          line-height: 1.4;
        }

        .save-button-row {
          margin-top: 24px;
          margin-bottom: 24px;
          display: flex;
          justify-content: flex-start;
        }

        .save-button-row .update-button {
          min-width: 200px;
        }

        .update-button {
          padding: 12px 24px;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          background: #0E141B;
          color: white;
        }

        .update-button:hover:not(:disabled) {
          background: #00A396;
        }

        .update-button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }


        .info-content {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .info-item h5 {
          margin: 0 0 12px 0;
          font-size: 15px;
          color: #333;
        }

        .info-item ol,
        .info-item ul {
          margin: 0;
          padding-left: 20px;
        }

        .info-item li {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin-bottom: 6px;
        }

        .info-item strong {
          color: #333;
        }

        .error-message {
          margin-top: 20px;
          padding: 12px 16px;
          background: #FCEDE9;
          border: 1px solid #F7DCD4;
          border-radius: 4px;
          color: #C2452D;
          font-size: 14px;
        }

        .channel-section {
          margin-top: 32px;
          padding-top: 24px;
          border-top: 1px solid #E6EDEC;
        }

        @media (max-width: 768px) {
          .api-key-input-row {
            flex-direction: column;
            align-items: stretch;
          }

          .update-button {
            width: 100%;
          }

          .info-item ol,
          .info-item ul {
            padding-left: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default SendOnAPIPanel;
